exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-module-header[data-v-a10d097a]{height:100px}", ""]);

// exports
